import React from 'react';
import {
  Line,
  LineChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Bar,
  BarChart,
  Legend,
} from 'recharts';

import { answerColorDict } from '../../../resources/thematic-topics';
import {
  formatForTimelineSingleChoice,
  removeYearFromArray
} from './utils.js'

const TimelineNumberChart = props => {
  const { results, participation, numberStates } = props;
  results.sort((first, second) => first.reportingYear - second.reportingYear);

  let formattedParticipationResults = null;
  let allowedParticipationKeys = [];

  if (participation.length > 0) {
    formattedParticipationResults = formatForTimelineSingleChoice(
      participation
    );
    allowedParticipationKeys = removeYearFromArray(
      Object.keys(formattedParticipationResults[0])
    );
  }

  const MainChart = () => {
    return (
      <LineChart
        width={400}
        height={100}
        data={results}
        margin={{ top: 0, right: 30, left: 20, bottom: 0 }}
        syncId="put_in_perspective"
      >
        <XAxis dataKey="reportingYear" />
        <YAxis domain={[0, numberStates]} />
        <CartesianGrid strokeDasharray="3 3" />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="count"
          stroke="#018571"
          activeDot={{ r: 5 }}
        />
      </LineChart>
    );
  };

  const ParticipationChart = () => {
    return (
      <span>
        <h5>Participation related to this question</h5>
        <BarChart
          width={400}
          height={100}
          data={formattedParticipationResults}
          margin={{ top: 0, right: 30, left: 20, bottom: 5 }}
          maxBarSize={100}
          syncId="put_in_perspective"
        >
          <XAxis dataKey="year" />
          <YAxis domain={[0, numberStates]} />
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip />
          <Legend />
          {/* For this type of chart we need to mention the Bars individually...: */}
          {allowedParticipationKeys.map(keyName => (
            <Bar
              key={keyName}
              dataKey={keyName}
              stackId="a"
              fill={answerColorDict[keyName]}
            />
          ))}
        </BarChart>
      </span>
    );
  };

  return (
    <span>
      <MainChart />
      {!!formattedParticipationResults && <ParticipationChart />}
    </span>
  );
};

export default TimelineNumberChart;



// WEBPACK FOOTER //
// ./src/components/Statistics/Views/TimelineNumberChart.js